import { render, staticRenderFns } from "./UserLoginForm.vue?vue&type=template&id=0b60c538&scoped=true&"
import script from "./UserLoginForm.vue?vue&type=script&lang=js&"
export * from "./UserLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./UserLoginForm.vue?vue&type=style&index=0&id=0b60c538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60c538",
  null
  
)

export default component.exports